module.exports = __webpack_public_path__ + "img/logo.8d4e2cf3.jpg";